import React from "react";
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { hasPermission, apiPost, getHostApi } from '../../store/apiWrapper';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { withLocalize, Translate } from "react-localize-redux";
import { withRouter } from 'react-router';
import classnames from 'classnames';
import { toast } from '../common/toast';

import XlsxExport from '../../img/icons/BBicons_Export-XLSX';

class CsvExportButton extends React.Component {
    static defaultProps = {
        style: {},
        disabled: false,
        asButton: false,
        offlineExport: false,
        report: null,
        portfolioId: null
    };

    state = {
        isChecking: false
    };

    render() {
        if (!hasPermission(null, 'ReportExport'))
            return null;

        if (this.props.asButton)
            return this.renderButton();
        else
            return this.renderLink();
    }

    renderLink = () => {
        return (
            <div style={{ fontSize: "0.9em", ...this.props.style }} className="print-hidden is-hidden-mobile">
                {this.props.disabled ? <span style={{ display: "flex", marginRight: "auto", cursor: "not-allowed" }}>
                    {this.renderLinkInner(true)}
                </span> : <a download onClick={() => this.buttonClick()}
                    title={isNullOrUndefined(this.props.title) ? "Csv" : this.props.title}
                    style={{ display: "flex", marginRight: "auto" }} disabled={this.props.disabled}
                >
                    {this.renderLinkInner(false)}
                </a>}
            </div>
        );
    }

    renderLinkInner = (disabled) => {
        const cursor = disabled ? "not-allowed" : "pointer";
        return (
            <>
                <XlsxExport className="svg-standard-fill icon-centered export-icon" style={{ width: "1.5em", height: "1.5em", cursor: cursor }}/>
                <span className="link-external" style={{ marginLeft: "0.5em", cursor: cursor }}>
                    <Translate id="Common.ExportToCsv" />
                </span>
                {this.state.isChecking ? <span style={{ marginLeft: "0.25em" }}><FontAwesomeIcon icon="cog" color="#898989" spin /></span> : null}
            </>
        );
    }

    renderButton = () => {
        return (
            <>
                <button type="button"
                    className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                    onClick={() => this.buttonClick()} disabled={this.props.disabled}
                >
                    <Translate id="Common.ExportToCsv" />
                </button>
            </>
        );
    }

    buttonClick = () => {
        if (this.props.offlineExport && this.props.report === "PortfolioSubjectsCsv") {
            apiPost(getHostApi() + `/api/portfolio/${this.props.portfolioId}/subjects/exportCsv`, undefined, this.props.language, undefined,
                () => toast(this.props.translate("UnhappyUser.InternalServerError"), "error"));
        } else if (this.props.offlineExport && this.props.report === "PropertySkReportCsv") {
            const data = { ...this.props.propertySk, language: this.props.language };
            this.checkBeforeExport(`${getHostApi()}/api/cadastre-sk/${this.props.propertySk.link}/csv-export-check`, data,
                () => apiPost(getHostApi() + `/api/cadastre-sk/${this.props.propertySk.link}/csv-export`, undefined, data, undefined,
                    () => toast(this.props.translate("UnhappyUser.InternalServerError"), "error")));
        } else {
            this.props.onClick();
        }
    }

    checkBeforeExport = (checkLink, data, onCheckSuccessfulAction) => {
        this.setState({ isChecking: true });
        apiPost(checkLink, undefined, data,
            (s) => {
                this.setState({ isChecking: false });
                if (s.data.isSuccess) {
                    this.props.onCheckSuccessful();  
                    onCheckSuccessfulAction();    
                    return true;              
                } else
                    this.props.onCheckFailed(s.data.exception || "Common.Error", s.data.exceptionData);
            },
            (_) => {
                this.setState({ isChecking: false });
                this.props.onCheckFailed("Common.Error");
            }
        );
    }
}

export default withLocalize(withRouter(connect(
    state => ({ language: state.userContext.language }),
)(CsvExportButton)));